'use client';

import { useEffect, useState } from 'react';
import { useHandleError } from '@/hooks/useHandleError';
import { apiFetch } from '@/lib/api/apiClient';
import { Magazine, MagazineHubType, MagazineResponse, MagazineSeries } from '@/types/magazines';
import { TaxRate } from '@/types/taxRate';
import ServiceHeader from '@/components/layout/service/ServiceHeader';
import MagazineListUnit from '@/(routers)/magazines/list/components/unit/MagazineListUnit';
import MagazineSeriesList from '@/(routers)/magazines/list/components/unit/MagazineSeriesList';

type MagazineListProps = {
    hubType?: MagazineHubType;
};

const getMagazineListApiPath = (hubType: MagazineHubType) => {
    if (hubType === 'stage') {
        return '/magazines/stage';
    }

    return '/magazines';
};

export default function MagazineList({ hubType = 'spot' }: MagazineListProps) {
    const { handleError } = useHandleError();
    const [magazineData, setMagazineData] = useState<Magazine[] | null>(null);
    const [magazineSeriesData, setMagazineSeriesData] = useState<MagazineSeries[]>([]);
    const [taxRateData, setTaxRateData] = useState<TaxRate[] | null>(null);

    useEffect(() => {
        (async () => {
            try {
                const data: MagazineResponse = await apiFetch(getMagazineListApiPath(hubType));
                setMagazineData(data.magazines);
                setMagazineSeriesData(data.magazine_series);
                setTaxRateData(data.tax_rates);
            } catch (error: unknown) {
                handleError(error);
            }
        })();
    }, [hubType]);

    return (
        <>
            <ServiceHeader title="LINEUP." />
            <div className="flex justify-center w-full mt-5 pb-12">
                <div className="flex flex-col w-full md:w-[98%] gap-8">
                    {magazineSeriesData.length > 0 && <MagazineSeriesList seriesList={magazineSeriesData} />}

                    <div className="flex w-full justify-center items-start">
                        {magazineData && magazineData.length > 0 && (
                            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-8 md:gap-4">
                                {magazineData.map((data) => (
                                    <MagazineListUnit
                                        key={data.magazine_cd}
                                        data={data}
                                        taxRates={taxRateData}
                                        hubType={hubType}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
